/**
 * Created by flj on 2019/3/6 .
 */
import React, { Component, PureComponent } from 'react';
import './index.less';
class SmallHeader extends (PureComponent || Component) {
	render () {
		const { title, subTitle, logo } = this.props;
		const prefixCls = 'eh-smallHeader-component';

		return (
			<div className={prefixCls}>
				<div className={`${prefixCls}-info`}>
					<div className='logo'>
						<img src={logo} />
					</div>

					{/* <div className='title'>{title || '商户平台'}</div> */}
				</div>
				{/* {subTitle ? <div className={`${prefixCls}-subTitle`}>{subTitle}</div> : ''} */}
			</div>
		);
	}
}

export default SmallHeader;
